import { render, staticRenderFns } from "./workerCertificateOther.vue?vue&type=template&id=1a5fc882&"
import script from "./workerCertificateOther.vue?vue&type=script&lang=js&"
export * from "./workerCertificateOther.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports